import { render } from "./404.svg?vue&type=template&id=bd810410"
const script = {}
script.render = render

export default script